// eslint-disable-next-line import/no-extraneous-dependencies
import { tns, TinySliderSettings, TinySliderInstance, TinySliderInfo } from 'tiny-slider/src/tiny-slider';
import classify from '../../helpers/classify';
import getOptions from '../hero/getOptions';
import { initAllMotion } from '../motion/motion';

const MULTI_LINK = 'cms-multi-link';
const MULTI_LINK_CAROUSEL = 'cms-multi-link--carousel';
const CAROUSEL = 'cms-multi-link__carousel';
const NAV_CONTAINER = 'tns-nav';
const NAVIGATION_LINE = 'cms-multi-link__nav-line';
const CONTROLS_CONTAINER = 'cms-multi-link__controls-container';
const OPTIONS = 'cms-multi-link__options';
const HIDE = 'hide';

const defaultTilesConfig = { 0: { items: 1 }, 768: { items: 2 }, 1200: { items: 3 }, 1440: { items: 4 } };

export function initMultiLink(multiLink: HTMLDivElement): void {
  const container = multiLink.querySelector<HTMLDivElement>(classify(CAROUSEL));
  const controlsContainer = multiLink.querySelector<HTMLDivElement>(classify(CONTROLS_CONTAINER));
  const configuration = getOptions(multiLink, OPTIONS) || defaultTilesConfig;

  if (!container || !controlsContainer) {
    return;
  }

  const sliderOptions: TinySliderSettings = {
    container,
    controlsContainer,
    loop: false,
    preventActionWhenRunning: true,
    mouseDrag: true,
    responsive: configuration,
    navPosition: 'bottom',
    gutter: 32
  };

  const slider = tns(sliderOptions);
  const { pages } = slider.getInfo() as TinySliderInfo & { pages: number };

  if (pages > 1) {
    initNavigation(multiLink, slider);
  } else {
    slider.destroy();
    initAllMotion(multiLink);
  }
}

function initNavigation(multilink: HTMLElement, slider: TinySliderInstance): void {
  const navContainer = multilink.querySelector<HTMLDivElement>(classify(NAV_CONTAINER));
  const controlsContainer = multilink.querySelector<HTMLDivElement>(classify(CONTROLS_CONTAINER));

  controlsContainer?.classList.remove(HIDE);
  multilink.classList.add(MULTI_LINK_CAROUSEL);

  (function createNavLineElement(): void {
    const navLine = document.createElement('div');
    navLine.classList.add(NAVIGATION_LINE);
    navContainer?.firstElementChild?.appendChild(navLine);
  })();

  function updateNavigation(): void {
    const navLine = multilink.querySelector<HTMLHRElement>(classify(NAVIGATION_LINE));
    const info = slider.getInfo() as TinySliderInfo & { pages: number };

    if (!info.pages || !navLine) {
      return;
    }

    const currentPage = info.navCurrentIndex || 0;
    navLine.style.marginLeft = `${100 * currentPage}%`;
  }

  slider.events.on('indexChanged', updateNavigation);
}

const findAllMultiLink = (): NodeListOf<HTMLDivElement> =>
  document.querySelectorAll<HTMLDivElement>(classify(MULTI_LINK));

type InitAllMultiLinkProps = {
  disablePreview: boolean;
};

export function initAllMultiLink({ disablePreview }: InitAllMultiLinkProps = { disablePreview: false }): void {
  if (disablePreview) {
    return;
  }
  const allMultiLink = findAllMultiLink();
  allMultiLink.forEach(initMultiLink);
}
